import { Spinner } from "@monbits/ui";
import type * as React from "react";

interface Props {
	isLoading: boolean;
}

const SpinWithMask: React.FC<Props> = (props: Props) => {
	return props.isLoading ? (
		<div className="absolute inset-0 flex items-center justify-center w-full h-full bg-background/70 backdrop-blur-sm z-10">
			<Spinner />
		</div>
	) : null;
};

export default SpinWithMask;
